module.exports = __webpack_public_path__ + "static/walls_night-3db836bc5efeb697afbbfe4e0a854ec1.jpg";